export function fillLevels(freqData, out) {
  const len = freqData.length
  const n = out.length
  let sum = 0
  for (let i = 0; i < len; i += 1) sum += freqData[i]
  const avg = sum / len / 255
  const t = performance.now() / 1000
  const idleBoost = avg < 0.02 ? 0.12 + 0.06 * Math.sin(t * 2.4) : 0

  for (let i = 0; i < n; i += 1) {
    const binStart = Math.floor((i / n) * len * 0.88)
    const binEnd = Math.min(len - 1, binStart + 2)
    let v = 0
    for (let b = binStart; b <= binEnd; b += 1) v += freqData[b]
    v /= (binEnd - binStart + 1) * 255
    v = Math.min(1, v * 2.4 + idleBoost * (0.5 + 0.5 * Math.sin(t * 3 + i * 0.12)))
    const prev = out[i]
    out[i] = prev * 0.38 + v * 0.62
  }
}
